// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import signinReducer from "./slice/signinSlice";
import clientManagementReducer from "./slice/clientmanagementSlice";
import mfaStatusReducer from "./slice/mfaStatusSlice";
import userManagementReducer from "./slice/usermanagementSlice";
import advisorManagementReducer from "./slice/advisormanagementSlice";
import resetReducer from "./slice/resetSlice";
import setupAccountReducer from "./slice/setupAccountSlice";
import documentReducer from "./slice/documentSlice";
import resendInviteReducer from "./slice/resendInviteSlice";
import profileReducer from "./slice/profileSlice";
import auditLogsReducer from "./slice/auditlogSlice";
import commonReducer from "./slice/commonSlice";
import clientFinancialAdvisorReducer from "./slice/clientFinancialAdvisorSlice";
import revokeInviteReducer from "./slice/revokeInviteSlice";
import advClientreducer from "./slice/advClientSlice";
import advDocumentReducer from "./slice/advDocumentSlice";
import advisorDocumentReducer from "./slice/advisorDocumentSlice";
import bulkActionReducer from "./slice/bulkActionSlice";
import clientPortfolioSlice from "./slice/clientDocumentSlice";
import filtersDropdownReducer from "./slice/FiltersDropdownSlice";
import clientIdReducer from "./slice/clientIdSlice";
import portfolioReducer from "./slice/portfolioSlice";
import  advisorsFilterSlice from "./slice/documentadvisorFilterSlice";
import clientsFilterSlice from "./slice/documentClientFilterSlice";
import documentsecuritiesSlice from "./slice/documentsecuritiesFilter";
import documentCategorySlice from "./slice/docCategorySlice";
import userContextSlice from "./slice/userStoreSlice";
import fetchClientsAccountsSlice from "./slice/clientAccount";
import fetchPortfolioAccountsSlice from "./slice/portfolioAccountSlice";
import userAccountReducer from "./slice/docAccountSlice";
import  fetchMonthlyInvestmentSlice from "./slice/monthlyInvestmentSlice";
import distributionHistorySlice from "./slice/distributionHistorySlice";
import performanceReducer  from "./slice/performanceSlice";
import accountGroupedInvestmentSlice from "./slice/accountGroupedInvestmentSlice";
import investmentAccountTypeSlice from "./slice/investmentAccountTypeSlice";
import downloadDocuments from "./slice/documentDownlaodSlice";
import changeRequestsReducer from "./slice/changeRequestSlice";
import relatedPartyReducer from "./slice/relatedPartySlice";
import reportsReducer from "./slice/reportsSlice";
import sendReportReducer from "./slice/sendReportSlice";
import investorReportsReducer from "./slice/investorReportsSlice";
import reportsDownloadReducer from "./slice/reportsDownloadSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const portfolioPersistConfig = {
  key: "portfolio",
  storage
};

const persistedPortfolioReducer = persistReducer(
  portfolioPersistConfig,
  portfolioReducer
);

const store = configureStore({
  reducer: {
    signin: signinReducer,
    clientManagement: clientManagementReducer,
    userMfaStatus: mfaStatusReducer,
    userManagement: userManagementReducer,
    advisorManagement: advisorManagementReducer,
    reset: resetReducer,
    setup: setupAccountReducer,
    document: documentReducer,
    resendInvite: resendInviteReducer,
    profile: profileReducer,
    auditLogs: auditLogsReducer,
    common: commonReducer,
    clientFinancialAdvisor: clientFinancialAdvisorReducer,
    revokeInvite: revokeInviteReducer,
    advClient: advClientreducer,
    advDocument: advDocumentReducer,
    advisorDocuments: advisorDocumentReducer,
    bulkAction: bulkActionReducer,
    clientDocument: clientPortfolioSlice,
    filtersDropdown: filtersDropdownReducer,
    clientId: clientIdReducer,
    portfolio: persistedPortfolioReducer,
    docadvfilter:advisorsFilterSlice,
    downloadDocuments: downloadDocuments,
    docclientfilter:clientsFilterSlice,
    docsecuritiesfilter:documentsecuritiesSlice,
    documentCategories: documentCategorySlice,
    userContextResponse:userContextSlice,
    fetchClientsAccountsResponse:fetchClientsAccountsSlice,
    fetchPortfolioAccountsResponse:fetchPortfolioAccountsSlice,
    userAccountSliceResponse:userAccountReducer,
    fetchMonthlyInvestmenResponse:fetchMonthlyInvestmentSlice,
    distributionHistoryResponse:distributionHistorySlice,
    performanceResponse:performanceReducer,
    accountGroupedInvestment:accountGroupedInvestmentSlice,
    investmentAccountTypeReponse:investmentAccountTypeSlice,
    changeRequests: changeRequestsReducer,
    relatedParty: relatedPartyReducer,
    reports: reportsReducer,
    sendReport: sendReportReducer,
    investorReports: investorReportsReducer,
    reportsDownload: reportsDownloadReducer,
  },
   middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
